import { Settings } from '@xeetr/types/models'
import { Plus, XCircle } from 'lucide-react'
import { useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { v4 as uuid } from 'uuid'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { ConfirmDialog } from '@/components/ui/confirm-dialog'
import { Input } from '@/components/ui/input'
import { useConfirmDialog } from '@/hooks/common/useConfirmDialog'
import { cn } from '@/lib/utils'

const ServiceCategory = () => {
  const { control } = useFormContext<Settings>()

  const { fields, remove, append, update } = useFieldArray({ control, name: 'tenant.categories' })

  const [newCategory, setNewCategory] = useState('')
  const confirmDialog = useConfirmDialog()

  const handleDelete = (index: number) => {
    confirmDialog.confirm(
      {
        title: 'Löschen bestätigen!',
        description:
          'Möchten Sie diese Kategorie wirklich löschen? Alle Dienstleistungen verlieren diese Kategorie!',
        confirmText: 'Löschen',
        cancelText: 'Abbrechen',
        variant: 'destructive',
      },
      () => remove(index)
    )
  }

  return (
    <div className="my-4 flex flex-col gap-4">
      <div className="mb-6">
        <h2 className="text-lg font-semibold">Kategorien</h2>
        <p className="text-muted-foreground text-sm">
          Verwalten Sie die Dienstleistungskategorien, um Ihre Angebote besser zu organisieren.
        </p>
      </div>
      <div className="flex">
        <Input
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
          className="w-min rounded-r-none"
        />
        <Button
          className="rounded-l-none"
          onClick={() => {
            if (!newCategory) return
            append({ id: uuid(), name: newCategory, active: true })
            setNewCategory('')
          }}
        >
          <Plus className="h-4 w-4 md:mr-2" />
          <p className="hidden md:block">Hinzufügen</p>
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {fields.map((value, index) => (
          <Badge
            key={value.id}
            variant={value.active ? 'default' : 'secondary'}
            className={cn('cursor-pointer gap-2 text-white', {
              'bg-gray-400 hover:bg-gray-500': !value.active,
            })}
            onClick={() => {
              update(index, { ...value, active: !value.active })
            }}
          >
            <span>{value.name}</span>
            <XCircle
              className="h-4 w-4 cursor-pointer rounded-full hover:bg-red-500"
              onClick={(event) => {
                event.stopPropagation()
                handleDelete(index)
              }}
            />
          </Badge>
        ))}
      </div>
      <ConfirmDialog
        open={confirmDialog.isOpen}
        onOpenChange={confirmDialog.setIsOpen}
        title={confirmDialog.options.title}
        description={confirmDialog.options.description}
        confirmText={confirmDialog.options.confirmText}
        cancelText={confirmDialog.options.cancelText}
        variant={confirmDialog.options.variant}
        onConfirm={confirmDialog.handleConfirm}
      />
    </div>
  )
}

export default ServiceCategory
